// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 1, // Greif
    },
    // Greif
    secondaryHeaderHeight: [45],
    cookies: {
        showChangeCustomerPageVariant: "showChangeCustomerPageVariant",
    },
    breakpoints: [0, 600, 900, 1200, 1500],
    pageType: {
        orderChangeRequest: "OrderChangeRequestPage",
        reviewOrderChangeRequest: "ReviewOrderChangeRequestPage",
        taxExemptionCertificates: "TaxExemptionCertificatesPage" as any,
        tecContactSupport: "TECContactSupportPage" as any,
        tecSubmitNew: "TECSubmitNewPage" as any,
        myReports: "MyReportsPage" as any,
        report: "ReportPage" as any,
        featureNotes: "FeatureNotesPage" as any,
        featureNotesList: "FeatureNotesListPage" as any,
        resetPassword: "ResetPasswordPage" as any,
        inviteYourColleague: "InviteYourColleaguePage" as any,
        recommendedProductRequest: "RecommendedProductRequestPage" as any,
        alternatePackagingPage: "AlternatePackagingPage" as any,
        instructionVideos: "InstructionVideosPage" as any,
        liveplants: "LivePlantsPage" as any,
        shipmentHistory: "ShipmentHistoryPage" as any,
        trailerTracking: "TrailerTrackingPage" as any,
        notificationPreferences: "NotificationPreferencesPage" as any,
    },
    widgetGroup: {
        orderChangeRequest: "Order Change Request" as any,
        reviewOrderChangeRequest: "Review Order Change Request" as any,
        orderComplaint: "Order Complaint" as any,
        taxExemptionCertificates: "TEC" as any,
        tecContactSupport: "TEC Contact Support" as any,
        tecSubmitNew: "TEC Submit New" as any,
        myReports: "My Reports" as any,
        report: "Report" as any,
        featureNotes: "Feature Notes" as any,
        featureNotesList: "Feature Notes List" as any,
        resetPassword: "Reset Password" as any,
        inviteYourColleague: "InviteYourColleaguePage" as any,
        recommendedProductRequest: "Recommended Product Request" as any,
        alternatePackagingPage: "Product Alternate Packaging" as any,
        instructionVideos: "InstructionVideosPage" as any,
        liveplants: "Live Plants" as any,
        shipmentHistory: "Shipment History" as any,
        trailerTracking: "Trailer Tracking" as any,
        notificationPreferences: "Notification Preferences" as any,
    },
    fileType: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    systemLists: {
        shipmentStatus: "Shipment Status",
    },
    shipTosOptions: {
        showAll: "Show All",
        showMine: "Show My Ship-Tos",
    },
    regexPatterns: {
        email: /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi,
    },
});
